import { useEffect } from "react";
import { connect } from "react-redux";
import { learningProgramsRequest } from "../../../store/slices/selfSlice";
import { RoundSlider } from "../../common/charts";
import Section from "../../common/section";

const CircularProgressWidget = ({
  learningProgramsRequest,
  learningPrograms,
}) => {
  useEffect(() => {
    learningProgramsRequest();
  }, []);

  const progress = learningPrograms.reduce(
    (acc, program) => {
      return {
        total: acc.total + program.completionCount.totalCount,
        completed: acc.completed + program.completionCount.completedCount,
      };
    },
    { total: 0, completed: 0 }
  );

  return (
    <Section title="overall_progress" className="edelxms-widget">
      <RoundSlider progress={(progress.completed / progress.total) * 100} />
    </Section>
  );
};

const mapStateToProps = (state) => ({
  learningPrograms: state.self?.learningPrograms || [],
});

const mapDispatchToProps = (dispatch) => ({
  learningProgramsRequest: () => dispatch(learningProgramsRequest()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CircularProgressWidget);
